module.exports = __webpack_public_path__ + "static/media/30.179a372c.mp3";